import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const routeSpecialties = [
  {
    title: "DEAD-ZONE COURIER RUNS",
    text: "High-speed crossings through irradiated sectors where automated vehicles lose signal and ordinary convoys turn back.",
  },
  {
    title: "SAFE-ZONE SUPPLY LINES",
    text: "Low-profile ground movement between settlements, water plants, border patrols, and fortified civilian hubs.",
  },
  {
    title: "QUANTUM-BATTERY ESCORT",
    text: "Manual handling for unstable power cells, using route memory, decoy timing, and ground-level evasion when autonomous systems are compromised.",
  },
  {
    title: "RELIC & INTEL RECOVERY",
    text: "Retrieval of pre-collapse hardware, encrypted drives, and black-market artifacts from ruins marked too dangerous for official salvage crews.",
  },
];

export function WasteRunnerLore() {
  const [open, setOpen] = useState(false);

  return (
    <section className="waste-runner-lore" data-testid="waste-runner-lore-section">
      <div className="archive-head">
        <SectionHeading
          eyebrow="WASTELAND RUNNER ARCHIVE"
          insignia={{
            src: "/assets/wr-runner-badge.png",
            alt: "Wasteland Runners official stamp — Est. after Second Apocalypse, Sectors 00-17, Independent Couriers",
            testid: "wr-archive-badge",
          }}
          title="Routes are inherited. Survival is earned."
          text="Wasteland Runners emerged after the Second Apocalypse as independent ground couriers who could cross sectors too unstable for machines, militias, or corporate convoys."
        />
        <button
          type="button"
          className={`manifesto-toggle silent-night-toggle ${open ? "is-open" : ""}`}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          data-testid="wr-archive-toggle"
        >
          {open ? "SEAL THE ARCHIVE" : "OPEN THE ARCHIVE"}
          <ChevronDown size={15} />
        </button>
      </div>
      <div className={`manifesto-collapse ${open ? "is-open" : ""}`} data-testid="wr-archive-collapse">
        <div className="manifesto-collapse-inner">
          <div className="waste-history-panel">
            <Reveal>
              <p>
                Their network began as a chain of hand-marked maps, hidden fuel caches, and remembered safehouses.
                Every route is earned through contact: which bridge still holds, which signal tower is compromised,
                which patrol rotates at dawn, and which stretch of highway belongs to the swarm.
              </p>
              <p>
                A Wasteland Runner does not promise speed alone. They promise arrival. The job is to read terrain,
                disappear when the network watches, and deliver cargo that cannot be trusted to autonomous systems.
              </p>
            </Reveal>
          </div>

          <div className="route-specialty-grid" data-testid="route-specialties-grid">
            {routeSpecialties.map((route, index) => (
              <Reveal className="route-specialty-card" delay={index * 0.06} key={route.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{route.title}</h3>
                <p>{route.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
